export default __webpack_public_path__ + "55d4d5f5d7a5139d2a6a8df7754d5e8a.png";